import '../../Styles/Sass/FAQ.scss';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#74ABBA',
    boxShadow: 'none',
    borderBottom: '2px solid white',
    padding: '0rem 0rem'
  },
  parentRoot: {
  	border: "none",
  	backgroundColor: 'rgba(0,0,0,0)',
  	boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    width: '80%',
  },
  heading: {
    fontWeight: theme.typography.fontWeightBold,
    color: 'white',
    fontSize: '2.083vw'
  },
  expandIcon: {
  	color: 'white',
  },
  text: {
  	color: 'white',
  	fontSize: '1.563vw',
  	padding: '1.172vw 0'
  }
}));

export default function FAQ() {
  const classes = useStyles();
  return (
    <section className='FAQ'>
      <h2 className='FAQ__title'>FAQ'S</h2>
      <Accordion classes={{ root: classes.parentRoot }}>
        <AccordionSummary
          classes={{
          	root: classes.root,
          	expandIcon: classes.expandIcon
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        	<Typography className={classes.heading}><strong>+</strong> Question Title</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography classes={{ root: classes.text }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
              sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
    	</Accordion>
      <Accordion classes={{ root: classes.parentRoot }}>
        <AccordionSummary
          classes={{
          	root: classes.root,
          	expandIcon: classes.expandIcon
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        	<Typography className={classes.heading}><strong>+</strong> Question Title</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography classes={{ root: classes.text }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
              sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
    	</Accordion>
      <Accordion classes={{ root: classes.parentRoot }}>
        <AccordionSummary
          classes={{
          	root: classes.root,
          	expandIcon: classes.expandIcon
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        	<Typography className={classes.heading}><strong>+</strong> Question Title</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography classes={{ root: classes.text }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
              sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
    	</Accordion>
      <Accordion classes={{ root: classes.parentRoot }}>
        <AccordionSummary
          classes={{
          	root: classes.root,
          	expandIcon: classes.expandIcon
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        	<Typography className={classes.heading}><strong>+</strong> Question Title</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography classes={{ root: classes.text }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
              sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
    	</Accordion>
      <Accordion classes={{ root: classes.parentRoot }}>
        <AccordionSummary
          classes={{
          	root: classes.root,
          	expandIcon: classes.expandIcon
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        	<Typography className={classes.heading}><strong>+</strong> Question Title</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography classes={{ root: classes.text }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
              sit amet blandit leo lobortis eget.
          </Typography>
        </AccordionDetails>
    	</Accordion>
    </section>
  );
}